import { CheckedAddress } from '@sparkdotfi/common-universal'

import { TokenLinksDropdown } from './TokenLinksDropdown'
import { AutomatedMarketBadge } from '@/features/sparklend/markets/components/automated-market-badge/AutomatedMarketBadge'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { assets } from '@/ui/assets'
import SwapIcon from '@/ui/assets/page/swap-icon.svg?react'
import { ExternalLink, InternalLink } from '@/ui/atoms/link/Link'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { links } from '@/ui/constants/links'
import { Alert } from '@/ui/molecules/alert/Alert'

interface HeaderProps {
  token: SparkLendToken
  aToken: SparkLendToken
  variableDebtTokenAddress: CheckedAddress
  chainName: string
  chainMismatch: boolean
  chainId: number
  sllManaged: boolean
  swapAvailable: boolean
  isUsdcViaUsdsProxyMarket: boolean
}

export function Header({
  token,
  aToken,
  variableDebtTokenAddress,
  chainName,
  chainMismatch,
  chainId,
  sllManaged,
  swapAvailable,
  isUsdcViaUsdsProxyMarket,
}: HeaderProps) {
  return (
    <div className="mt-6 mb-4 flex flex-col gap-4 sm:mt-8 sm:mb-10">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col items-start gap-4 lg:flex-row lg:justify-between">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-3 px-3 md:ml-5 lg:px-0">
              {isUsdcViaUsdsProxyMarket ? (
                <img
                  src={assets.markets.usdcViaUsdsProxyMarketIcon}
                  alt="usdc-via-usds-proxy-market-icon"
                  className="size-8"
                />
              ) : (
                <TokenIcon token={token} className="size-8" />
              )}
              {isUsdcViaUsdsProxyMarket ? (
                <h1 className="typography-heading-3 sm:typography-heading-2 lg:typography-heading-1 -mt-1 text-primary">
                  USDC via USDS
                </h1>
              ) : (
                <h1 className="typography-heading-1 -mt-1 text-primary">{token.symbol}</h1>
              )}
              {sllManaged && <AutomatedMarketBadge />}
              <TokenLinksDropdown
                token={token}
                aToken={aToken}
                variableDebtTokenAddress={variableDebtTokenAddress}
                chainId={chainId}
              />
            </div>
            {isUsdcViaUsdsProxyMarket && (
              <div className="typography-label-4 ml-3 text-secondary md:ml-16">
                Borrow USDS and swap 1:1 for USDC.{' '}
                <span className="whitespace-nowrap">
                  <ExternalLink to={links.docs.swap} variant="secondary">
                    Learn more
                  </ExternalLink>
                </span>
              </div>
            )}
          </div>
          {import.meta.env.VITE_FEATURE_SWAP_PAGE === '1' && swapAvailable && (
            <div className="flex items-center gap-2 rounded-md bg-primary p-2 md:p-4">
              <SwapIcon className="icon-size-sm" />
              <div className="typography-label-3">
                Swap between stablecoins without fees.{' '}
                <InternalLink to="/swap" variant="secondary">
                  Swap
                </InternalLink>
              </div>
            </div>
          )}
        </div>
      </div>
      {chainMismatch && (
        <Alert variant="warning">
          You are currently viewing {chainName} asset details. To view assets from connected chain, go back to the
          markets page.
        </Alert>
      )}
    </div>
  )
}
